import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import '../RouterSelfInstallBlock/Assets/RouterSelfInstallBlock.scss';
import Config from 'app/Config';
import ClockIcon from '../RouterSelfInstallBlock/Assets/SVG/ClockIcon';
import BtnWhiteBlackBorderBigSize from 'app/Components/Shared/Buttons/BtnWhiteBlackBorderBigSize';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import {HebrewCalendar, HDate, HebrewDateEvent, isAssurBemlacha, Location, getHolidaysOnDate, flags, holidayDesc} from '@hebcal/core';
import context from 'react-bootstrap/esm/AccordionContext';
import {getReportParams, report} from 'app/middleware/report';

const OpeningHoursReferralMain = (props) => {
  const [showError, setError] = useState(false);
  const openingHourRegular = props.iContent?.openingHourRegular?.value ? parseInt(props.iContent?.openingHourRegular?.value) : 8;
  const closingHourRegular = props.iContent?.closingHourRegular?.value ? parseInt(props.iContent?.closingHourRegular?.value) : 19;
  const openingHourEvent = props.iContent?.openingHourEvent?.value ? parseInt(props.iContent?.openingHourEvent?.value) : 8;
  const closingHourEvent = props.iContent?.closingHourEvent?.value ? parseInt(props.iContent?.closingHourEvent?.value) : 13;
  const urlParams = new URLSearchParams(window.location.search);
  const routerParam = props.mlParams?.model ? props.mlParams?.model : urlParams?.get('ModemName');

  useEffect(() => {
    if (routerParam) {
      const routerChosen = props.iContent?.guideLinks?.expandedValue?.find((r) => r.modemName?.value == routerParam);
      if (routerChosen?.guideUrl?.value) {
        if (props.iContent?.useHours?.value) {
          //check for hours
          // Get the current Gregorian date
          const today = new Date(); // Get today's date
          const _today = new Date();
          _today.setHours(12);
          const tomorrow = new Date(_today); // Create a new Date object based on today
          tomorrow.setDate(today.getDate() + 1); // Increment the day by 1
          let isClosed =
            isAssurBemlacha(_today, Location.lookup('Tel Aviv'), true) ||
            getHolidaysOnDate(new HDate(_today))?.findIndex((e) => e.getDesc & holidayDesc.YOM_HAATZMA_UT) > -1 ||
            ((isAssurBemlacha(tomorrow, Location.lookup('Tel Aviv'), true) ||
              getHolidaysOnDate(new HDate(tomorrow))?.findIndex((e) => e.getDesc & holidayDesc.YOM_HAATZMA_UT) > -1) &&
              (today.getHours() >= closingHourEvent || today.getHours() < openingHourEvent)) ||
            today.getHours() >= closingHourRegular ||
            today.getHours() < openingHourRegular;

          if (isClosed) {
            reportFailure();
            setError(true);
          } else {
            reportSuccess();
            props.context.navigateTo(routerChosen.guideUrl?.value);
          }
        } else {
          reportSuccess();
          props.context.navigateTo(routerChosen.guideUrl?.value);
        }
      } else {
        //no url for guide
        reportFailure();
        setError(true);
      }
    } else {
      //no router found
      reportFailure();
      setError(true);
    }
  }, []);

  const reportSuccess = () => {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'Support';
    reportParams.subArea = 'SelfSetupRouterProcess';
    reportParams.actionType = 'User Entered Guide via SMS/QR';
    reportParams.status = 'Completed';
    reportParams.messageText = 'Guide screen displayed';
    report(reportParams);
  };

  const reportFailure = () => {
    let reportParams = getReportParams();
    reportParams.channel = 'WebsitePrivate';
    reportParams.area = 'Support';
    reportParams.subArea = 'SelfSetupRouterProcess';
    reportParams.actionType = 'User Entered Guide via SMS/QR';
    reportParams.status = 'Error';
    reportParams.messageText = 'Guide screen failed to load';
    report(reportParams);
  };
  const hoursText = (
    <>
      {' '}
      <p className='heading'>הגעת לחיבור הנתב החדש שלך</p>
      <p className='subHeading mb-12'>אפשר להמשיך בתהליך רק בשעות הפעילות שלנו:</p>
      <p className='subHeading mb-12'>
        ימי א-ה' בין השעות {closingHourRegular}:00 - {openingHourRegular}:00
      </p>
      <p className='subHeading mb-12'>
        ימי ו' בין השעות {closingHourEvent}:00 - {openingHourEvent}:00
      </p>{' '}
    </>
  );
  const modemText = (
    <>
      <p className='subHeading mb-12'>הלינק שנכנסת דרכו לתהליך לא תקין מכיוון שלא כולל התייחסות לנתב</p>
      <p className='subHeading mb-12'>יש להכנס מהלינק בסמס או ע"י סריקת הברקוד</p>
    </>
  );

  if (showError) {
    return (
      <div className='RouterSelfInstallBlock'>
        <ClockIcon />
        <div className='headBox mb-12'>{routerParam ? hoursText : modemText}</div>
        <div className='fixFooter'>
          <BtnWhiteBlackBorderBigSize
            text='סיום'
            onclick={() => {
              prepareSameWindowUrlWithNavigateTo(Config.lobbyUrl);
            }}
          />
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

const mapStateToProps = (state) => ({
  mlParams: state.authentication?.loginData?.magicLinkParameters,
});

export default connect(mapStateToProps)(OpeningHoursReferralMain);
